export default __webpack_public_path__ + "static/media/logo-sm.f08759ea.png";